import { render, staticRenderFns } from "./yidongshebei.vue?vue&type=template&id=248e9049&scoped=true"
import script from "./yidongshebei.vue?vue&type=script&lang=ts"
export * from "./yidongshebei.vue?vue&type=script&lang=ts"
import style0 from "./yidongshebei.vue?vue&type=style&index=0&id=248e9049&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e9049",
  null
  
)

export default component.exports